// Angular
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import {Component, Input, Inject, ChangeDetectionStrategy, Injector} from '@angular/core';

// Miscellaneous
import moment from 'moment';
import * as utils from '../../../util';
import { Guest } from '../../../models';
import * as fromRoot from '../../../reducers';
import * as olci from '../../../actions/olci';
import { CONSTANTS } from '../../../constants';
import * as tracking from '../../../actions/tracking';
import { GuestService } from '../services/guest.service';
import { BrowserUtils } from '../../../utils/browser.utils';
import { LoaderService } from '../../loading/loader.service';
import * as guestActions from '../../../actions/guest.actions';
@Component({
    selector: 'app-guest-checkin-completed',
    templateUrl: './guest-checkin-completed.component.html',
    styleUrls: ['./guest-checkin-completed.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [BrowserUtils],
    standalone: false
})
export class GuestCheckinCompletedComponent {
	@Input() public guestsCompleted: any[] = [];
	@Input() public session: any;
	@Input() public bundle: any;

  private loader: LoaderService;
  public guestService: GuestService;
  public browserUtils: BrowserUtils;

	constructor(
		private readonly router: Router,
		private location: Location,
    private injector: Injector,
    private route: ActivatedRoute,
    private readonly store: Store<fromRoot.AppState>,
		@Inject(CONSTANTS) public constants: any,
	) {
    this.injectServices();
  }

  injectServices() {
    this.loader = this.injector.get<LoaderService>(LoaderService);
    this.guestService = this.injector.get<GuestService>(GuestService);
    this.browserUtils = this.injector.get<BrowserUtils>(BrowserUtils);
  }

	trackByFn(index: any, item: any) {
		return item.guestId;
	}

	goBack(event: any) {
		event.preventDefault();
		this.location.back();
	}

	isSailingClose() {
		const date = new Date();
		const localDate = moment(date.toLocaleDateString('en-US'), this.constants.DATE_FORMAT.GUEST_ACCOUNT).format(
			this.constants.DATE_FORMAT.SERVER
		);
		if (moment(localDate).isAfter(this.session.departureDate)) {
			this.store.dispatch(new tracking.TrackPageInteractionEventAction('alert: guests checked-in component: checkin is closed'));
			return true;
		}

		if (moment(localDate).isSame(this.session.departureDate)) {
			if (!this.isPriorToMidnigth(date)) {
				return true;
			}
		}
		return false;
	}

	isPriorToMidnigth(date: any) {
		let totalMinutes = 0;
		const localTime = date.toLocaleTimeString('en-US', { hour12: false }).split(':', 2);
		if (localTime.length >= 2) {
			totalMinutes = parseInt(localTime[0], 10) * 60 + parseInt(localTime[1], 10);
		}
		return 1439 - totalMinutes >= 0;
	}

	getGuestLastName(guest: Guest) {
		return utils.getGuestLastName(guest);
	}

	getGuestBoardingPass(guestId: any, bookingId: any) {
		const payload = {
			bookingId: bookingId,
			guestId: guestId
		};
		this.store.dispatch(new guestActions.SelectGuestIdBookingIdAction(payload));
		this.browserUtils.openInNewTab(this.constants.ROUTES.BOARDING_PASS);
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('guests checked-in component: boarding pass link'));
	}

	editGuest(guest: Guest) {
		this.guestService.resetSelectedGuestState();
		this.store.dispatch(new olci.SetResponseErrorClearAction());
		this.loader.showLoader();
		this.store.dispatch(new guestActions.SelectGuestForEditAction(guest.guestId));
		const payload = {
			bookingId: guest.bookingId,
			guestId: guest.guestId
		};
		this.store.dispatch(new guestActions.SelectGuestIdBookingIdAction(payload));
		this.router.navigate([this.constants.ROUTES.GUEST_DETAILS]);
	}

	guestStatus(guest: Guest) {
		return guest.boardingPassPendingStatus ? this.bundle['tool.tip.boarding.pass.pending'] : '';
	}
}
